import { useQuery } from "@tanstack/react-query";

import { UserDTO, getUsers, getUsersBySiteId } from "api";

import { QUERY_KEYS } from "consts";

export const useGetUsers = (enabled: boolean = true) =>
  useQuery<UserDTO[]>([QUERY_KEYS.USERS], getUsers, { enabled });

export const useUsersBySiteId = (siteId: number) =>
  useQuery<UserDTO[]>([QUERY_KEYS.USERS, QUERY_KEYS.SITES, siteId], () =>
    getUsersBySiteId(siteId),
  );
